var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7084 5.30208C21.1763 4.76979 20.5446 4.34754 19.8494 4.05946C19.1541 3.77137 18.4089 3.62309 17.6563 3.62309C16.9037 3.62309 16.1585 3.77137 15.4632 4.05946C14.7679 4.34754 14.1362 4.76979 13.6042 5.30208L12.5 6.40624L11.3959 5.30208C10.3212 4.2274 8.86362 3.62365 7.34379 3.62365C5.82397 3.62365 4.36639 4.2274 3.29171 5.30208C2.21703 6.37676 1.61328 7.83433 1.61328 9.35416C1.61328 10.874 2.21703 12.3316 3.29171 13.4062L12.5 22.6146L21.7084 13.4062C22.2407 12.8742 22.6629 12.2425 22.951 11.5472C23.2391 10.852 23.3874 10.1068 23.3874 9.35416C23.3874 8.60157 23.2391 7.85635 22.951 7.16108C22.6629 6.46581 22.2407 5.83412 21.7084 5.30208Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.0081432e9556637098cf9dca99c63c37.svg";
export { ForwardRef as ReactComponent };